import { Entity } from "@/shared/Entity";

export class Role extends Entity {
    static ADMINISTRATOR_NAME = "administrador";
    static PROFESSOR_NAME = "profesor";
    static POSTGRADE_NAME = "posgrado";
    static COUNCIL_NAME = "consejo";
}